import http from "../httpService";

const apiEndpoint = "/report/data";

export function getReportDataSummary(input) {
  const query = (input) ? Object.keys(input).map(key=> { return `${key}=${input[key]}`}).join('&') : ''
  
  return http.get(apiEndpoint + '/summary' + ((query) ? '/?' + query : ''))
}


export function getReportPerData(id, input) {
  const query = (input) ? Object.keys(input).map(key=> { return `${key}=${input[key]}`}).join('&') : ''

  return http.get(apiEndpoint + '/' + id + ((query) ? '/?' + query : ''))
}


